// extracted by mini-css-extract-plugin
export default {"container":"c78e7d43","titleRow":"dccc9e70"};